import React from 'react';
import { Currency, UnitOfMeasure } from '../../../../Generated/Raven-Demeter';
import { IExchangeCommoditySelection } from '../../../Components/Navigation/Hooks/useExchangeCommodityNavigationHook';
import { FuturesPricesForwardCurveChartProps } from '../../Futures/Prices/FuturesPricesForwardCurveChart';
import { IWithPageElementProps } from '../DashboardCustomizationDefinitions';

const withFuturesPricesForwardCurveChartFromPageElement = (
    FuturesPricesForwardCurveChart: React.ComponentType<FuturesPricesForwardCurveChartProps>,
): React.FC<IWithPageElementProps> => {
    const Wrapped: React.FC<IWithPageElementProps> = (props) => {
        if (!props.pageElement) {
            return <> </>;
        }

        const { demeterPageElementGuid, commodity, exchange, currency, unitOfMeasure } = props.pageElement;

        const exchangeCommoditySelection = {
            commodity,
            exchange,
        } as IExchangeCommoditySelection;

        const chartProps: FuturesPricesForwardCurveChartProps = {
            exchangeCommoditySelection,
            customTitle: props.customTitle,
            currency: currency ?? Currency.Usd,
            unitOfMeasure: unitOfMeasure ?? UnitOfMeasure.MetricTon,
            testId: `dashboard-futures-prices-forward-curve-chart-${demeterPageElementGuid}`,
            dragIndicatorIcon: props.dragIndicatorIcon,
            isInDashboardEditMode: props.isInDashboardEditMode,
            maximizeMinimizeButton: props.maximizeMinimizeButton,
            maxWidthHeightRatio: props.maxWidthHeightRatio,
            handleMoreOptionsSelection: props.handleMoreOptionsSelection,
            track: props.track,
        };

        return <FuturesPricesForwardCurveChart {...chartProps} />;
    };

    return Wrapped;
};

export default withFuturesPricesForwardCurveChartFromPageElement;
